import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import Loading from "../../../../../pages/Loading/Loading";

const MenuAdvaltech = lazy(() =>
  import("../../../../../features/print-tags").then((module) => ({
    default: module.MenuAdvaltech,
  }))
);

export const Route = createFileRoute(
  "/$lang/_authenticated/menu-print-tags/advaltech"
)({
  component: () => (
    <Suspense fallback={<Loading />}>
      <MenuAdvaltech />
    </Suspense>
  ),
});
